import { PRODUCT_CONTAINER_WRAPPER } from 'src/constants/elementIds';

export const scrollToTopOfProductsList = () => {
  const productContainerOffsetTop = document.getElementById(PRODUCT_CONTAINER_WRAPPER)?.offsetTop;

  if (!productContainerOffsetTop) {
    window.scrollTo({ top: productContainerOffsetTop, behavior: 'auto' });
  }
};
